import { GarageDetailsAdditionalData } from "../interfaces/Interfaces";

export const parseGarageDetails = (json: string | undefined | null): GarageDetailsAdditionalData | null => {
    if (!json) return null;

    try {
        return JSON.parse(json);
    } catch (e) {
        console.error("Invalid garage details JSON:", e);
        return null;
    }
};
